module.exports = __webpack_public_path__ + "img/partner_img15.e7e72822.png";